<script lang="ts">
  import { useNavigate } from 'svelte-navigator';
  import { _ } from 'svelte-i18n';

  import Analytics from '../../services/analytics';

  import Link from './Link.svelte';
  import PoweredBy from './PoweredBy.svelte';

  export let category = 'logged-in-state';
  export let onClickHowItWorks: any = undefined;

  const navigate = useNavigate();

  const t = (text: string) => {
    return $_(`dashboard.${text}`);
  };

  const goToHowItWorks = () => {
    Analytics.logEvent('click-how-it-works', category);
    if (onClickHowItWorks) onClickHowItWorks();
    else {
      navigate('/how-it-works');
    }
  };
</script>

<div class="twism-footer__link">
  <Link width="unset" fontWeight="500" on:click={goToHowItWorks}>
    {t('how_it_works')}
  </Link>
  <PoweredBy />
</div>

<style lang="scss">
  :global(.twism-footer__link .twism-popover__footer) {
    width: 123px;
    margin: 0 !important;
    bottom: 0 !important;
  }

  .twism-footer__link {
    width: 100%;
    padding: 16px 24px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    position: absolute;
    background-color: $color-white;
    box-shadow: 0px 0px 16px rgba(1, 42, 90, 0.06);
    bottom: 0;
    z-index: 5;
  }
</style>
